export default "__VITE_ASSET__CaODRaXS__"